import { Box, CircularProgress, Typography } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { CheckCircle } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import WatchLaterIcon from "@mui/icons-material/WatchLater";

import moment from "moment";

export const docTransmittalCols = (to, isArchived) => {
  const archivedDetails = isArchived
    ? []
    : [
        {
          header: "#",
          accessorFn: (row, rowIndex) => rowIndex + 1,
          size: 10,
          enableSorting: false,
          enableEditing: false,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          Edit: () => <></>,
        },
      ];

  return [
    ...archivedDetails,
    {
      accessorKey: "sent",
      header: "Sent Information",
      columns: [
        {
          id: "docNumber",
          accessorKey: "number",
          header: "Doc. Transmittal Number",
          size: 200,
        },
        {
          id: "rev",
          accessorKey: "rev",
          header: "Rev.",
          size: 50,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
        },
        {
          id: "date",
          accessorKey: "date",
          header: "Date",
          size: 100,
          Cell: ({ row }) => {
            return moment(row.original.createdAt).fromNow();
          },
        },
        {
          id: "receiver",
          accessorKey: "receiver",
          header: to,
          size: 100,
          Cell: ({ row }) => {
            return (
              <Box
                sx={{
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {row?.original?.vendor?.name || row?.original?.customer?.name}{" "}
                <LinkIcon sx={{ transform: "translateY(6px)" }} />
              </Box>
            );
          },
        },
        {
          id: "Project",
          accessorKey: "Project",
          header: "Project",
          size: 100,
          Cell: ({ row }) => {
            return (
              <Box
                sx={{
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {row?.original?.project?.name}{" "}
                <LinkIcon sx={{ transform: "translateY(6px)" }} />
              </Box>
            );
          },
        },

        {
          id: "remarks",
          accessorKey: "remarks",
          header: "Lifecycle",
          size: 200,
        },
      ],
    },
    {
      accessorKey: "received",
      header: to + " Information",
      columns: [
        {
          id: "status",
          accessorKey: "status",
          header: "Status",
          size: 100,
          Cell: ({ cell }) => {
            const status = cell.getValue();

            const getStatusIcon = (status) => {
              switch (status) {
                case "Updates In Progress":
                  return (
                    <WatchLaterIcon
                      sx={{
                        color: "#EFB034FF",
                        mr: 1,
                        transform: "translateY(-1px)",
                      }}
                    />
                  );
                case "Under Review":
                  return (
                    <VisibilityIcon
                      sx={{
                        color: "#379AE6FF",
                        mr: 1,
                        transform: "translateY(-1px)",
                      }}
                    />
                  );

                case "Sent For Review":
                  return (
                    <MarkEmailReadIcon
                      sx={{
                        color: "#CAC0E2FF",
                        mr: 1,
                        transform: "translateY(-1px)",
                      }}
                    />
                  );
                case "Approved":
                  return (
                    <CheckCircle
                      sx={{
                        color: "#1DD75BFF",
                        mr: 1,
                        transform: "translateY(-1px)",
                      }}
                    />
                  );
                default:
                  return (
                    <VisibilityIcon
                      sx={{
                        color: "gray",
                        mr: 1,
                        transform: "translateY(-1px)",
                      }}
                    />
                  );
              }
            };

            return (
              <Box display="flex" alignItems="center">
                {getStatusIcon(status)} {status}
              </Box>
            );
          },
        },
        {
          id: "receivedDate",
          accessorKey: "receivedDate",
          header: "Received Date",
          size: 100,
        },
        {
          id: "revisedDate",
          accessorKey: "revisedDate",
          header: "Last Revised Date",
          size: 100,
        },
        {
          id: "progress",
          accessorKey: "progress",
          header: "Progress %",
          size: 50,
          muiTableHeadCellProps: {
            align: "center",
          },
          muiTableBodyCellProps: {
            align: "center",
          },
          Cell: ({ row }) => {
            const value = row?.original?.progress || 20;
            return (
              <Box sx={{ position: "relative", display: "inline-flex" }}>
                <CircularProgress
                  variant="determinate"
                  color={value == 100 ? "success" : "primary"}
                  value={value}
                />
                <Box
                  sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="caption"
                    component="div"
                    sx={{ color: "text.secondary" }}
                  >
                    {`${Math.round(value)}%`}
                  </Typography>
                </Box>
              </Box>
            );
          },
        },
      ],
    },
  ];
};
